var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{ref:"postBody",class:{
    'wish-body-content': true,
    'wish-body-content-light dark:wish-body-content-dark': _vm.darkMode === 'auto',
    'wish-body-content-light': _vm.darkMode === false,
    'wish-body-content-dark': _vm.darkMode === true,
    'break-words': true,
    'text-dark-text-100 dark:text-light-text-100': _vm.darkMode === 'auto',
    'text-dark-text-100': _vm.darkMode === false,
    'text-light-text-100': _vm.darkMode === true,
    'select-text': _vm.isTextSelectable,
  },domProps:{"innerHTML":_vm._s(_vm.body)}})
}
var staticRenderFns = []

export { render, staticRenderFns }